
import React, { createContext, ReactNode, useContext } from 'react';

interface HooksAccountOrdersData {
  isTrue: boolean,
}

const AccountOrdersContext = createContext<HooksAccountOrdersData>(
  {} as HooksAccountOrdersData,
);

interface AccountOrdersContextProviderProps {
  children: ReactNode;
}

const AccountOrdersContextProvider: React.FC<AccountOrdersContextProviderProps> = ({ children }: AccountOrdersContextProviderProps) => {
  const isTrue = false;
  return (
    <AccountOrdersContext.Provider
      value={{isTrue}}
    >
      {children}
    </AccountOrdersContext.Provider>
  );
};

function useAccountOrders(): HooksAccountOrdersData {
  const context = useContext(AccountOrdersContext);

  if (!context) {
    throw new Error('useAccountOrders must be used within a useAccountOrders');
  }

  return context;
}


export { AccountOrdersContextProvider, useAccountOrders };
